import type { EnvironmentProviders, Provider } from '@angular/core';
import { providePluginAppBaseHref, type PluginAppBaseHrefOptions } from './plugin-app-base-href';
import { providePhoenixPluginRouterInitialNavigation } from './provide-phoenix-plugin-router';

export type ProvidePhoenixPluginOptions = PluginAppBaseHrefOptions;

/**
 * Common providers for an Angular Phoenix web-component plugin: `APP_BASE_HREF`, deferred router
 * `initialNavigation` (for custom-element bootstrap), and sync when the host sidebar changes the URL.
 */
export function providePhoenixPlugin(options?: ProvidePhoenixPluginOptions): (Provider | EnvironmentProviders)[] {
  return [providePluginAppBaseHref(options), providePhoenixPluginRouterInitialNavigation()];
}
